<template>
  <div class="content">
    <center-nav ref="centerNav" @getBuySeatIndex="getBuySeat"></center-nav>
    <!--    有小程序座位席位时且绑定了小程序-->
    <slider-menu
      :menuData="menuData"
      v-if="seatNum > 0 && openAppList.length > 0 && isMerchant == 1"
    ></slider-menu>
    <creditCard v-if="seatNum === 0"></creditCard>
    <authorization
      @getBuySeat="getBuySeat"
      v-if="openAppList.length > 0 && isMerchant == 0"
    ></authorization>
    <auto v-if="seatNum > 0 && openAppList.length === 0 && !isAuto"></auto>
  </div>
</template>

<script>
import mini from "@/api/mini";
const miniModel = new mini();
import centerNav from "../../../components/centerNav";
import sliderMenu from "@/components/SliderMenu";
import creditCard from "../../pc/miniProgram/creditCard/index";
import authorization from "../../pc/miniProgram/authorization/index";
import pay from "../../pc/miniProgram/pay/index";
import auto from "../../pc/miniProgram/auto/index";
export default {
  components: {
    centerNav, // 头部导航
    sliderMenu, // 侧边栏
    creditCard,
    authorization,
    pay,
    auto,
  },
  data() {
    return {
      seatNum: "", //小程序席位数量
      openAppList: [],
      isAuto: false, //是否授权
      packagePitList: [],
      isMerchant: 0, // 是否已经绑定商户号
      ipOpenCoupon: false, // 优惠券开关
      menuData: [
        {
          path: "/pc/miniProgram/home",
          icon: "icon-xcx_refresh_home_n_1",
          title: "主页",
          hidden: false,
          iconSize: "16px",
        },
        {
          path: "/pc/miniProgram/user",
          icon: "icon-xcx_refresh_user_n_2",
          title: "用户列表",
          hidden: false,
          iconSize: "16px",
        },
        {
          path: "/pc/miniProgram/orderMovie",
          icon: "icon-xcx_refresh_order_n_3",
          title: "影票订单",
          iconSize: "16px",
          hidden: false,
          children: [
            {
              path: "/pc/miniProgram/order",
              title: "小程序推广订单",
            },
          ],
        },

        {
          path: "/pc/miniProgram/audit",
          icon: "icon-xcx_refresh_await_n_5",
          title: "提现审核",
          hidden: false,
          iconSize: "16px",
        },
        {
          path: "/pc/miniProgram/financialDetails",
          icon: "icon-xcx_refresh_detail_n_6",
          title: "资金明细",
          hidden: false,
          iconSize: "16px",
        },

        {
          path: "/pc/miniProgram/set",
          icon: "icon-xcx_refresh_set_n_8",
          title: "基础设置",
          hidden: false,
          iconSize: "16px",
        },
      ],
    };
  },
  computed: {
    isSaasProxyUser: function () {
      return this.$store.getters.isSaasProxyUser;
    },
  },
  created() {
    console.log("SDFFH11111");
    // this.getBuySeat();
    console.log(this.$route.query, "AAAA====");
  },
  async mounted() {
    await this.getBuySeat();
    console.log(this.isSaasProxyUser, "this.isSaasProxyUser==1");
    let miniAppType = localStorage.getItem("miniAppType");
    console.log(miniAppType, "miniAppType== 3和undefined开启==");
    let appKey = localStorage.getItem("appKeyMini");
    if (this.$route.query.isAuto) {
      this.isAuto = this.$route.query.isAuto;
    }
    console.log("SDFFH");
    // await this.getBuySeat();
    // miniAppType：1淘宝，2天猫，3抖音，4支付宝，5快手
    // 快手、支付宝、淘宝、天猫、好影抖音影藏 活动中心菜单栏
    // 极光测试环境：16045865425：好影：19235541328正式环境：好影：16663046825
    // 微信和抖音显示活动中心 + 快手极光小程序'14447955848'
    // 极光：16045865425测试环境：好影：19235541328正式环境：好影：16663046825
    let couponArr = ["1", "2", "4", "5"];
    console.log(couponArr.indexOf(miniAppType), "ASD");
    // 微信和抖音极光显示 【活动中心】。抖音好影隐藏【活动中心】 isSaasProxyUser==1
    console.log(miniAppType, "miniAppTypeminiAppTypeminiAppTypeminiAppType");
    if (miniAppType == "0" || (miniAppType == "3" && this.isSaasProxyUser != 1)) {
      this.getUserCoupon();
    } else if (miniAppType == "5" && this.isSaasProxyUser !== 1) {
      let activeItem = {
        path: "/pc/miniProgram/couponParams",
        icon: "icon-xcx_refresh_detail_n_6",
        title: "活动中心",
        iconSize: "16px",
        hidden: false,
        children: [
          {
            path: "/pc/miniProgram/couponGroup",
            title: "团购券",
          },
        ],
      };

      let arr = this.menuData;
      arr.splice(5, 0, activeItem);

      arr.forEach((item) => {
        if (item.title === "影票订单") {
          item.children.push({
            path: "/pc/miniProgram/groupOrder",
            title: "团购订单",
          });
        }
      });
      this.menuData = [...arr];
    }

    // miniAppType：1淘宝，2天猫，3抖音，4支付宝，5快手，禁用菜单“推广工具”
    let miniAppTypeArr = ["1", "2", "3", "4", "5"];

    console.log(miniAppTypeArr.indexOf(miniAppType), "ASD==miniAppType");
    console.log(miniAppType, "miniAppType==");
    if (miniAppType !== null && miniAppTypeArr.indexOf(miniAppType) === -1) {
      this.menuData.push({
        path: "/pc/miniProgram/promotion",
        icon: "icon-xcx_refresh_tool_n_7",
        title: "推广工具",
        iconSize: "16px",
        hidden: false,
        children: [
          {
            path: "/pc/miniProgram/promotionManage",
            title: "推广位管理",
          },
          {
            path: "/pc/miniProgram/statisticalData",
            title: "统计数据",
          },
        ],
      });
    }
  },
  methods: {
    // 获取优惠券开关
    getUserCoupon() {
      let appKeyMini = localStorage.getItem("appKeyMini");
      let miniAppType = localStorage.getItem("miniAppType");
      miniModel
        .userCoupon({
          appKey: appKeyMini,
        })
        .then((res) => {
          if (res.data.code == 200) {
            console.log("获取优惠券开关菜单==", res);
            console.log(res.data.data.isOpenCoupon, "后台是否开启优惠券菜单权限");
            this.$store.commit("nav/SET_ISOPEN_DOUYIN", res.data.data.isDy);

            // 开启优惠券才有微信活动中心
            if (res.data.data.isOpenCoupon == 1) {
              let item = {
                path: "/pc/miniProgram/couponParams",
                icon: "icon-xcx_refresh_detail_n_6",
                title: "活动中心",
                iconSize: "16px",
                hidden: false,
                children: [
                  {
                    path: "/pc/miniProgram/coupon",
                    title: "小程序内部券",
                    hidden: !["0", "3"].includes(miniAppType),
                  },
                  {
                    path: '/pc/miniProgram/couponDy',
                    title: '抖音小程序营销券',
                    hidden: !["3"].includes(miniAppType),
                  }
                ],
              };
              let arr = this.menuData;
              arr.splice(5, 0, item);
              this.menuData = [...arr];
            }else{

            }
          }
        });
    },
    // 获取购买席位数量
    async getBuySeat(appKey) {
      await miniModel
        .getMiniNum({
          channelType: 0,
        })
        .then((res) => {
          console.log(res, "获取购买席位数量");
          if (res.data.code == 200) {
            this.seatNum = res.data.data.openAppList.length;
            this.packagePitList = res.data.data.packagePitList;
            this.openAppList = res.data.data.openAppList;

            if (this.openAppList.length == 0) return;
            console.log("openAppList有数据wx");
            // 设置缓存
            let miniActive = localStorage.getItem("miniActive");
            console.log(miniActive, "miniActive===223");
            if (miniActive === null) {
              console.log("VVV=111=miniActive为null");
              // 取第一个
              this.isMerchant = this.openAppList[0].isMerchant;
              localStorage.setItem("isMerchant", this.openAppList[0].isMerchant);
              localStorage.setItem("miniAppType", this.openAppList[0].miniAppType);
              localStorage.setItem("miniActive", 0);
              localStorage.setItem("appId", this.openAppList[0].id);
              localStorage.setItem("appKeyMini", this.openAppList[0].appKey);
              localStorage.setItem("appName", this.openAppList[0].appName);
            } else {
              console.log(this.openAppList[miniActive], "this.openAppList[miniActive]");
              if (this.openAppList[miniActive]) {
                console.log("有==11");

                this.isMerchant = this.openAppList[miniActive].isMerchant;
                localStorage.setItem(
                  "isMerchant",
                  this.openAppList[miniActive].isMerchant
                );
                localStorage.setItem(
                  "miniAppType",
                  this.openAppList[miniActive].miniAppType
                );
                // localStorage.setItem('miniActive', 0)
                localStorage.setItem("appId", this.openAppList[miniActive].id);
                localStorage.setItem("appKeyMini", this.openAppList[miniActive].appKey);
                localStorage.setItem("appName", this.openAppList[miniActive].appName);
              } else {
                // 索引超出时，取第一个
                console.log("没有==11");
                // 取第一个
                this.isMerchant = this.openAppList[0].isMerchant;
                localStorage.setItem("isMerchant", this.openAppList[0].isMerchant);
                localStorage.setItem("miniAppType", this.openAppList[0].miniAppType);
                localStorage.setItem("miniActive", 0);
                localStorage.setItem("appId", this.openAppList[0].id);
                localStorage.setItem("appKeyMini", this.openAppList[0].appKey);
                localStorage.setItem("appName", this.openAppList[0].appName);
              }
            }

            if (appKey != undefined) {
              console.log("授权资质AA");
              for (let index in this.openAppList) {
                if (this.openAppList[index].appKey == appKey) {
                  this.isMerchant = this.openAppList[index].isMerchant;
                  localStorage.setItem("isMerchant", this.openAppList[index].isMerchant);
                }
              }
            } else {
              console.log("授权资质BB");
              if (localStorage.getItem("isMerchant")) {
                this.isMerchant = localStorage.getItem("isMerchant");
              } else {
                if (this.openAppList.length > 0) {
                  this.isMerchant = this.openAppList[0].isMerchant;
                }
              }

              console.log(this.$route.query.appKey, "this.$route.query.appKey");
              console.log(this.$route.query, "this.$route.query");
              // 授权页面传值，选中对应项
              if (this.$route.query.appKey) {
                console.log("有传appkey");
                for (let index in this.openAppList) {
                  console.log("循环");
                  // appkey相同
                  if (this.openAppList[index].appKey == this.$route.query.appKey) {
                    // 是否打开授权页面
                    this.isMerchant = this.openAppList[index].isMerchant;
                    localStorage.setItem(
                      "isMerchant",
                      this.openAppList[index].isMerchant
                    );
                    localStorage.setItem("miniActive", index);
                    // appkey
                    localStorage.setItem("appKeyMini", this.$route.query.appKey);
                    // id
                    localStorage.setItem("appId", this.openAppList[index].id);
                    localStorage.setItem(
                      "miniAppType",
                      this.openAppList[index].miniAppType
                    );
                    localStorage.setItem("appName", this.openAppList[index].appName);
                    console.log(
                      index,
                      "index===56有传appkey的索引",
                      this.openAppList[index]
                    );
                  }
                }
              }

              if (localStorage.getItem("appId") != null) {
                const appId = localStorage.getItem("appId");
                for (let index in this.openAppList) {
                  if (this.openAppList[index].id == appId) {
                    this.isMerchant = this.openAppList[index].isMerchant;
                    this.appKey = this.openAppList[index].appKey;

                    localStorage.setItem("miniActive", index);
                    localStorage.setItem("appName", this.openAppList[index].appName);
                    console.log(index, 'index=getItem("appId")');
                    break;
                  } else {
                    this.isMerchant = this.openAppList[0].isMerchant;
                    this.appKey = this.openAppList[0].appKey;
                  }
                }
              }
            }
            this.$refs.centerNav.getBuySeat();
            console.log(
              "debug:________________this.isMerchant______________是否显示授权资质",
              this.isMerchant
            );
            // if (this.$refs.router != undefined) {
            //   this.$refs.router.getBuySeat()
            // }
          } else {
            this.$message.error(res.data.info);
          }
        });
    },
  },
};
</script>
<style scoped lang="less"></style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/index.vue